import unnumberedSeatsFactory from "../unnumberedSeat";

const AreasDOMRender = {
  order: 0,
  run($$) {
    $$.$.on("seats:rendering", () => {
      /* Render areas here */
      const fragment = $(document.createDocumentFragment());

      // draw stand seats
      $$.seatsData.areas.forEach((standSeat) => {
        // currently we did not have this parameters in server
        standSeat.coordinates = {
          row: 1,
          seat: 1,
          x: 1,
          y: 1,
        };
        standSeat.width = 702;
        standSeat.height = 308;

        $$.standSeatsWidth += standSeat.width;
        $$.standSeatsHeight += standSeat.height;

        $$.seats[`${standSeat.row}-${standSeat.seat}`] = standSeat;

        unnumberedSeatsFactory(fragment, standSeat, standSeat.width, standSeat.height);
      });

      fragment.appendTo($$.$seats);
    });
  },
};

window.SectionAreasDOMRender = AreasDOMRender;

export default AreasDOMRender;
